// Role constants based on the database schema
// These IDs correspond to the roles table in the database
export const ROLES = {
  SUPER_ADMIN: 1,
  BOOKING_STAFF: 2,
  BAR_STAFF: 3,
  CUSTOMER: 4,
  GUEST_USER: 5,
  READONLY: 6,
  HOST: 7,
} as const;

// Helper function to get role name by ID (for display purposes)
export const getRoleName = (roleId: number): RoleName | "unknown" => {
  switch (roleId) {
    case ROLES.SUPER_ADMIN:
      return "super_admin";
    case ROLES.BOOKING_STAFF:
      return "booking_staff";
    case ROLES.BAR_STAFF:
      return "bar_staff";
    case ROLES.CUSTOMER:
      return "customer";
    case ROLES.GUEST_USER:
      return "guest_user";
    case ROLES.READONLY:
      return "readonly";
    case ROLES.HOST:
      return "host";
    default:
      return "unknown";
  }
};

// Helper function to get role ID by name (for backward compatibility)
export const getRoleId = (roleName: string): number => {
  switch (roleName) {
    case "super_admin":
      return ROLES.SUPER_ADMIN;
    case "booking_staff":
      return ROLES.BOOKING_STAFF;
    case "bar_staff":
      return ROLES.BAR_STAFF;
    case "customer":
      return ROLES.CUSTOMER;
    case "guest_user":
      return ROLES.GUEST_USER;
    case "readonly":
      return ROLES.READONLY;
    case "host":
      return ROLES.HOST;
    default:
      return 0;
  }
};

// Type definitions
export type RoleId = (typeof ROLES)[keyof typeof ROLES];
export type RoleName =
  | "super_admin"
  | "booking_staff"
  | "bar_staff"
  | "customer"
  | "guest_user"
  | "readonly"
  | "host";
